import "./footer.css";

import React from "react";

import { CONTACT_DETAILS, CREDIT } from "../../data/content";

const Footer = () => {
  return (
    <footer className={"site-footer"}>
      <div className={"site-footer-inner container"}>
        <p className={"site-footer-name"}>
          <span className={"is-brown"}>Salgado's </span>
          <span className={"is-green"}>QUALITY </span>
          <span className={"is-brown"}>FOOD</span>
        </p>

        <address className={"site-footer-details"}>
          <span>
            <strong>Tel:</strong> <a href={CONTACT_DETAILS.PHONE.link}>{CONTACT_DETAILS.PHONE.label}</a>
          </span>
          <span>
            <strong>Email:</strong> <a href={`mailto:${CONTACT_DETAILS.EMAIL}?subject=Request%20for%20Information`}>{CONTACT_DETAILS.EMAIL}</a>
          </span>
          <span>
            <strong>Address:</strong> {CONTACT_DETAILS.ADDRESS}
          </span>
        </address>

        <p className={"site-footer-credit"}>
          © {new Date().getFullYear()} Salgados. Proudly created by{" "}
          <a
            href={CREDIT.link}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            {CREDIT.label}
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
